import { XeroTaxRate } from '../../../back-end/common/xeroTaxRate'

export const getTaxRateFromType = (type: string | undefined, version: string | undefined, xeroTaxRates: XeroTaxRate[]): { label: string; taxRate: number } => {
	const customTaxRate = xeroTaxRates.find((taxRate) => type === taxRate.taxType)
	if (customTaxRate) {
		return {
			label: customTaxRate.name!,
			taxRate: customTaxRate.effectiveRate!,
		}
	}

	if (version === 'AU') {
		if (type === 'OUTPUT') {
			return { label: 'GST on Income', taxRate: 0.1 }
		} else if (type === 'INPUT') {
			return { label: 'GST on Expenses', taxRate: 0.1 }
		} else if (type === 'EXEMPTEXPENSES') {
			return { label: 'GST Free Expenses', taxRate: 0.0 }
		} else if (type === 'EXEMPTOUTPUT') {
			return { label: 'GST Free Income', taxRate: 0.0 }
		} else if (type === 'BASEXCLUDED') {
			return { label: 'BAS Excluded', taxRate: 0.0 }
		} else if (type === 'GSTONIMPORTS') {
			return { label: 'GST on Imports', taxRate: 0.0 }
		}
	} else if (version === 'NZ') {
		throw new Error('TODO Implement for New Zealand')
	} else if (version === 'UK') {
		throw new Error('TODO Implement for United Kingdom')
	} else if (version === 'GLOBAL') {
		throw new Error('TODO Implement for Global')
	} else if (version === 'US') {
		throw new Error('TODO Implement for United State of America')
	} else if (version === 'SG') {
		throw new Error('TODO Implement for Singapore')
	} else if (version === 'SA') {
		throw new Error('TODO Implement for South Africa')
	}

	// Xero sends us 'NONE' when BASEXCLUDED is selected on a line in a 'NoTax' invoice - FOV-1363
	if (type === 'NONE') {
		return { label: 'Tax Exempt', taxRate: 0.0 }
	}

	return { label: '', taxRate: -1.23 }
}

export const australianDefaultTaxRates = [
	{ label: 'GST on Income', xeroID: 'OUTPUT', taxRate: 0.1, canApplyToRevenue: true, canApplyToExpenses: false },
	{ label: 'GST on Expenses', xeroID: 'INPUT', taxRate: 0.1, canApplyToRevenue: false, canApplyToExpenses: true },
	{ label: 'GST Free Expenses', xeroID: 'EXEMPTEXPENSES', taxRate: 0.0, canApplyToRevenue: false, canApplyToExpenses: true },
	{ label: 'GST Free Income', xeroID: 'EXEMPTOUTPUT', taxRate: 0.0, canApplyToRevenue: true, canApplyToExpenses: false },
	{ label: 'BAS Excluded', xeroID: 'BASEXCLUDED', taxRate: 0.0, canApplyToRevenue: true, canApplyToExpenses: false },
	{ label: 'GST on Imports', xeroID: 'GSTONIMPORTS', taxRate: 0.0, canApplyToRevenue: false, canApplyToExpenses: true },
	{ label: 'Tax Exempt', xeroID: 'NONE', taxRate: 0.0, canApplyToRevenue: false, canApplyToExpenses: true },
]
